<section class="body">
  <div class="body-wrapper">
    <p>{{errorState?.message}}</p>
    <simple-grid-handler *ngIf="!!data.externalData" [gridProperties]="data"></simple-grid-handler>
  </div>
</section>